<div class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
  <div class="flex items-center justify-center min-h-screen p-4">
    <div
      class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity duration-300"
      [class.opacity-100]="isVisible"
      [class.opacity-0]="!isVisible"
      (click)="onClose()"></div>

    <div
      class="relative z-10 w-full max-w-3xl bg-white dark:bg-slate-900 rounded-[1.75rem] shadow-2xl border border-slate-100 dark:border-slate-700 overflow-hidden transition-all duration-300"
      [class.opacity-100]="isVisible"
      [class.opacity-0]="!isVisible"
      [class.translate-y-0]="isVisible"
      [class.translate-y-4]="!isVisible"
      (click)="$event.stopPropagation()">

      <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex items-start justify-between gap-4 bg-white/90 dark:bg-slate-900/90 backdrop-blur-md">
        <div class="flex items-center gap-3">
          <div class="w-11 h-11 rounded-2xl bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 flex items-center justify-center">
            <span class="material-icons">payments</span>
          </div>
          <div>
            <h3 class="text-xl font-bold text-slate-800 dark:text-white">รายละเอียดรายได้</h3>
            <p class="text-xs text-slate-400 dark:text-slate-500 mt-0.5">Revenue Detail</p>
          </div>
        </div>
        <button (click)="onClose()"
          class="w-9 h-9 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-400 hover:text-amber-600 hover:border-amber-200 transition-colors flex items-center justify-center">
          <span class="material-icons text-[20px]">close</span>
        </button>
      </div>

      <div class="p-6 max-h-[70vh] overflow-y-auto custom-scrollbar bg-slate-50/60 dark:bg-slate-900/60">
        <div *ngIf="isLoading" class="py-16 flex flex-col items-center text-slate-400">
          <span class="material-icons text-4xl mb-2 animate-spin">sync</span>
          <span class="text-sm font-medium">กำลังโหลดข้อมูล...</span>
        </div>

        <div *ngIf="!isLoading && data" class="space-y-5">
          <div class="bg-white dark:bg-slate-800 rounded-2xl border border-slate-100 dark:border-slate-700 p-5 shadow-sm">
            <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200 mb-4 flex items-center gap-2">
              <span class="w-1 h-5 bg-amber-400 rounded-full"></span>
              ข้อมูลทั่วไป
            </h4>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
              <div>
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">เลขที่ใบเสร็จ</div>
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ data.receiptId || '-' }}</div>
              </div>
              <div>
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">สถานที่</div>
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ data.siteName || '-' }}</div>
              </div>
              <div>
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">รายการรายได้</div>
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ data.feeName || '-' }}</div>
              </div>
              <div>
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">ประเภทชำระเงิน</div>
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ data.feeType || '-' }}</div>
              </div>
              <div>
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">Invoice</div>
                <div class="font-bold text-amber-700 dark:text-amber-400">{{ data.invoiceNo || '-' }}</div>
              </div>
              <div>
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">ธนาคาร</div>
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ data.bankName || '-' }}</div>
              </div>
              <div class="sm:col-span-2">
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">รายละเอียด / หมายเหตุ</div>
                <div class="text-slate-700 dark:text-slate-200">{{ data.description || '-' }}</div>
              </div>
            </div>
          </div>

          <div class="bg-white dark:bg-slate-800 rounded-2xl border border-slate-100 dark:border-slate-700 p-5 shadow-sm">
            <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200 mb-4 flex items-center gap-2">
              <span class="w-1 h-5 bg-amber-400 rounded-full"></span>
              ยอดเงินและวันที่
            </h4>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div class="rounded-xl bg-slate-50 dark:bg-slate-900/50 p-4 border border-slate-100 dark:border-slate-700">
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">ค่าธรรมเนียม</div>
                <div class="text-lg font-black text-slate-800 dark:text-white">{{ data.fee | number:'1.2-2' }} ฿</div>
              </div>
              <div class="rounded-xl bg-slate-50 dark:bg-slate-900/50 p-4 border border-slate-100 dark:border-slate-700">
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">VAT</div>
                <div class="text-lg font-black text-slate-800 dark:text-white">{{ data.vat | number:'1.2-2' }} ฿</div>
              </div>
              <div class="rounded-xl bg-amber-50 dark:bg-amber-900/20 p-4 border border-amber-100 dark:border-amber-900/40">
                <div class="text-xs font-bold uppercase tracking-wider text-amber-600 dark:text-amber-400 mb-1">รวม</div>
                <div class="text-lg font-black text-amber-700 dark:text-amber-300">{{ displayTotal | number:'1.2-2' }} ฿</div>
              </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4 text-sm">
              <div>
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">วันที่ชำระ</div>
                <div class="font-medium text-slate-700 dark:text-slate-200">{{ data.paidDate | date:'dd/MM/yyyy HH:mm' }}</div>
              </div>
              <div>
                <div class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">วันที่บันทึก</div>
                <div class="font-medium text-slate-700 dark:text-slate-200">{{ data.createDate | date:'dd/MM/yyyy HH:mm' }}</div>
              </div>
            </div>
          </div>

          <div class="bg-white dark:bg-slate-800 rounded-2xl border border-slate-100 dark:border-slate-700 p-5 shadow-sm">
            <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200 mb-4 flex items-center gap-2">
              <span class="w-1 h-5 bg-amber-400 rounded-full"></span>
              รูปใบเสร็จ
            </h4>

            <div *ngIf="!data.attachments.length"
              class="py-8 flex flex-col items-center text-slate-400 dark:text-slate-500 rounded-xl border border-dashed border-slate-200 dark:border-slate-700">
              <span class="material-icons text-3xl mb-1">image_not_supported</span>
              <span class="text-sm">ไม่มีรูปแนบ</span>
            </div>

            <div *ngIf="data.attachments.length" class="grid grid-cols-2 sm:grid-cols-3 gap-3">
              <button type="button" *ngFor="let file of data.attachments" (click)="openPreview(file.fileUrl)"
                class="group relative aspect-[3/4] rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/50 hover:border-amber-400 transition-colors">
                <img [src]="file.fileUrl" [alt]="file.fileName || 'Receipt'" loading="lazy"
                  class="h-full w-full object-contain p-1" />
                <span
                  class="absolute inset-x-0 bottom-0 px-2 py-1 text-[11px] text-white bg-slate-900/60 truncate text-left">
                  {{ file.fileName || 'รูปใบเสร็จ' }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-900 flex justify-end">
        <button (click)="onClose()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
          ปิด
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="previewUrl" class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/80"
    (click)="closePreview()">
    <div class="absolute top-4 right-4 flex gap-2">
      <a [href]="previewUrl" target="_blank" rel="noopener" (click)="$event.stopPropagation()"
        class="w-10 h-10 rounded-xl bg-white/90 text-slate-700 hover:text-amber-600 flex items-center justify-center"
        title="เปิดในแท็บใหม่">
        <span class="material-icons text-[20px]">open_in_new</span>
      </a>
      <button type="button" (click)="closePreview()"
        class="w-10 h-10 rounded-xl bg-white/90 text-slate-700 hover:text-amber-600 flex items-center justify-center">
        <span class="material-icons text-[20px]">close</span>
      </button>
    </div>
    <img [src]="previewUrl" alt="Receipt" class="max-h-[90vh] max-w-full rounded-xl shadow-2xl bg-white"
      (click)="$event.stopPropagation()" />
  </div>
</div>
